<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        <template v-if="isDelete">
          Удален промокод
        </template>
        <template v-if="isAdd">
          Добавлен промокод
        </template>
        <template v-if="isEdit">
          Изменён промокод
        </template>
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <template v-if="isDelete">
        <label-with-icon icon="minus" bordered>
          {{ oldPromocodeName }}
        </label-with-icon>
      </template>
      <template v-if="isAdd">
        <label-with-icon icon="plus" bordered>
          {{ promocodeName }}
        </label-with-icon>
      </template>
      <template v-if="isEdit">
        <before-after-log-item class="os-history-item__promocode-edit-item">
          <template v-slot:before>
            <label-with-icon bordered>
              {{ oldPromocodeName }}
            </label-with-icon>
          </template>
          <template v-slot:after>
            <label-with-icon bordered>
              {{ promocodeName }}
            </label-with-icon>
          </template>
        </before-after-log-item>
      </template>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import LabelWithIcon
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/LabelWithIcon'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'

  export default {
    name: 'HistoryItemTypePromocode',
    components: { BeforeAfterLogItem, LabelWithIcon, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      isDelete () {
        return this.item.oldClientPromoCodeId !== null && this.item.clientPromoCodeId === null
      },
      isAdd () {
        return this.item.oldClientPromoCodeId === null && this.item.clientPromoCodeId !== null
      },
      isEdit () {
        return this.item.oldClientPromoCodeId !== null &&
          this.item.clientPromoCodeId !== null &&
          this.item.oldClientPromoCodeId !== this.item.clientPromoCodeId
      },

      oldPromocodeName () {
        return this.item?.oldClientPromoCode?.promoCode?.name || 'неизвестный промокод...'
      },
      promocodeName () {
        return this.item?.clientPromoCode?.promoCode?.name || 'неизвестный промокод...'
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
